/* ═══════════════════════════════════════════════════════════════════════════
   FILE: assets/2025-sticky-warenkorb-v2.js
   Isofin® Sticky Footer V2 – Pill + Bottom Sheet + Side Panel

   Mobile:  Full-width bar → Bottom Sheet Menü → delegate to sec-03 global fns
   Desktop: Floating Pill → Side Panel (von rechts) → delegate to sec-03 global fns

   Panel-Öffnung via window.openGuideModal / openGarantieModal / openWerkzeugModal
   (registriert durch 26-isowiz-step-4-sec-03.js)

   Scope: globally injected via theme.liquid (außer /cart, /checkout)
═══════════════════════════════════════════════════════════════════════════ */

(() => {
  'use strict';

  if (window.__MC_STICKY_V2_LOADED__) return;
  window.__MC_STICKY_V2_LOADED__ = true;

  // V27.7.14: Auf /pages/kalkulator nicht laden — der Wizard hat dort seine eigenen CTAs
  // (Inline-Button + interner Sticky-Footer). Sonst koennten Sticky-Cart und Result-Page
  // unterschiedliche Flaschenzahlen anzeigen (Cart-State vs. Calculated-State).
  try {
    var _p = (window.location.pathname || '').toLowerCase();
    if (_p.indexOf('/pages/kalkulator') === 0 || _p === '/pages/kalkulator/') {
      return;
    }
  } catch (_eEx) {}

  /* ═══════════════════════════════════════════════════════════════════════
     CONFIG
  ═══════════════════════════════════════════════════════════════════════ */
  var CFG = {
    CHECKOUT_URL: 'https://isofin.de/checkout',
    CALCULATOR_URL: 'https://isofin.de/pages/kalkulator',
    HERO_ANCHOR_URL: '/#hero',
    ISOFIN_VARIANT_ID: 55049427616117,
    FREE_SHIPPING_CENTS: 9900, /* v525.8: ab 99,00 € versandkostenfrei (Gleichstand mit der Copy) */
    /* v538: Abfrage nur noch als Sicherheitsnetz (andere Fenster, fremde Skripte ohne
       Ereignis). Aenderungen aus Kalkulator/Drawer/Produktseite kommen ueber Ereignisse
       und den fetch-Abfang sofort; im versteckten Tab wird gar nicht abgefragt. */
    POLL_INTERVAL_MS: 45000,
    /* v538: statt 10 s lang alle 0,6 s (ca. 17 Abrufe) nur drei Nachkontrollen
       nach einer Warenkorb-Aenderung (Geschenk-/Rabatt-Nachlauf von Shopify). */
    AFTER_CHANGE_MS: [200, 1500, 5000],
    MOBILE_MAX_WIDTH: 640,
    MOBILE_EMPTY_THRESHOLD: 500,
    DESKTOP_EMPTY_THRESHOLD: 400,
    PANEL_RETRY_MAX: 8,
    PANEL_RETRY_MS: 500,
    PANEL_BOOT_FILES: {
      sec03: '26-isowiz-step-4-sec-03.js',
      anleitung: '26-isowiz-panel-anleitung.js',
      material: '26-isowiz-panel-material.js',
      wirkung: '26-isowiz-panel-wirkung.js'
    },
    HERO_SCROLL_FLAG_KEY: '__ISOWIZ_SW2_SCROLL_TO_HERO__'
  };
  var STICKY_PANEL_ANALYSIS_KEY = '__ISOWIZ_STICKY_PANEL_ANALYSIS__';

  var STATE = {
    lastToken: '',
    panelEligible: false,
    lastBottleQty: 0,
    uiFilled: false,
    showSticky: false
  };

  var SCRIPT_PROMISES = {};
  var PREACT_COMPAT_PROMISE = null;

  function sizedShopifyImage(url, width) {
    if (!url || /[?&]width=/.test(url)) return url || '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + (width || 160);
  }

  /* ═══════════════════════════════════════════════════════════════════════
     PANEL CONFIG  (labels/icons for menu only — opening delegated to sec-03)
  ═══════════════════════════════════════════════════════════════════════ */
  var PANELS = {
    anleitung: {
      label: '3-Schritte Anleitung inkl. Bohrplan',
      icon: '📋',
      thumb: 'https://cdn.shopify.com/s/files/1/0846/5550/5691/files/isofin-starter-guide-500px.jpg?v=1761551030',
      sub: 'Individuell für Ihre Wand berechnet',
      globalFn: 'openGuideModal'
    },
    material: {
      label: 'Material',
      icon: '🧰',
      thumb: null,
      sub: 'Was Sie ben\u00f6tigen \u2013 meist bereits vorhanden',
      globalFn: 'openWerkzeugModal'
    }
  };

  /* ═══════════════════════════════════════════════════════════════════════
     HELPERS
  ═══════════════════════════════════════════════════════════════════════ */
  function isMobile() {
    return (window.innerWidth || 0) < CFG.DESKTOP_BP;
  }

  function fmt(cents) {
    return ((cents || 0) / 100)
      .toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '€';
  }

  function tokenize(cart) {
    try {
      var parts = (cart.items || []).map(function (i) { return i.id + ':' + i.quantity; }).join('|');
      return parts + '::' + (cart.item_count || 0) + '::' + (cart.total_price || 0);
    } catch (e) { return String(Date.now()); }
  }

  function bottleCount(cart) {
    var vid = CFG.ISOFIN_VARIANT_ID;
    return (cart.items || []).reduce(function (s, it) {
      var v = typeof it.variant_id === 'string' ? Number(it.variant_id) : it.variant_id;
      return v === vid ? s + (it.quantity || 0) : s;
    }, 0);
  }

  async function fetchCart() {
    try {
      var r = await fetch('/cart.js?_sw=' + Date.now(), {
        credentials: 'same-origin', cache: 'no-store',
        headers: { 'Cache-Control': 'no-store, no-cache', 'Pragma': 'no-cache' }
      });
      return r.ok ? await r.json() : null;
    } catch (e) { return null; }
  }

  function readStorageAll(key) {
    var values = [];
    try {
      var sessionVal = sessionStorage.getItem(key);
      if (sessionVal != null) values.push(sessionVal);
    } catch (_) {}
    try {
      var localVal = localStorage.getItem(key);
      if (localVal != null) values.push(localVal);
    } catch (_) {}
    return values;
  }

  function readStorage(key) {
    var values = readStorageAll(key);
    return values.length ? values[0] : null;
  }

  function parseJSON(raw) {
    if (!raw || typeof raw !== 'string') return null;
    try {
      var parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : null;
    } catch (_) {
      return null;
    }
  }

  function readStorageJSONCandidates(key) {
    var raws = readStorageAll(key);
    var out = [];
    for (var i = 0; i < raws.length; i++) {
      var parsed = parseJSON(raws[i]);
      if (parsed) out.push(parsed);
    }
    return out;
  }

  function readStorageJSONKey(key) {
    var candidates = readStorageJSONCandidates(key);
    return candidates.length ? candidates[0] : null;
  }

  function readNamespacedJSONCandidates(name) {
    var out = [];
    var keys = ['__ISOWIZ__::' + name, '__ISOWIZ_TEST__::' + name];
    for (var i = 0; i < keys.length; i++) {
      var parsedCandidates = readStorageJSONCandidates(keys[i]);
      for (var j = 0; j < parsedCandidates.length; j++) {
        out.push(parsedCandidates[j]);
      }
    }
    return out;
  }

  function readStorageModuleJSON(name) {
    try {
      var mod = window.IsoWiz && window.IsoWiz.Storage;
      if (mod && typeof mod.getJSON === 'function') {
        var data = mod.getJSON(name, null);
        if (data && typeof data === 'object') return data;
      }
    } catch (_) {}
    return null;
  }

  function hasCompleteAnalysis(a) {
    if (!a || typeof a !== 'object') return false;
    var bottles = Number(a.calculatedBottles || a.bottles || a.bottleCount || 0);
    var holes = Number(a.holeCount || 0);
    var spacing = Number(a.drillSpacingCm || a.spacing || 0);
    var depth = Number(a.drillDepthCm || a.drillDepth || 0);
    var wallThickness = Number(a.wallThicknessCm || a.wallThickness || 0);
    var moisture = String(a.moistureType || '').trim();
    var masonry = String(a.masonryType || '').trim();
    return (
      Number.isFinite(bottles) && bottles > 0 &&
      Number.isFinite(holes) && holes > 0 &&
      Number.isFinite(spacing) && spacing > 0 &&
      Number.isFinite(depth) && depth > 0 &&
      Number.isFinite(wallThickness) && wallThickness > 0 &&
      moisture.length > 0 &&
      masonry.length > 0
    );
  }

  function scoreAnalysisCandidate(a) {
    if (!a || typeof a !== 'object') return -1;
    var score = 0;
    if (Number(a.calculatedBottles || a.bottles || a.bottleCount || 0) > 0) score += 10;
    if (Number(a.holeCount || 0) > 0) score += 8;
    if (Number(a.drillDepthCm || a.drillDepth || 0) > 0) score += 6;
    if (Number(a.drillSpacingCm || a.spacing || 0) > 0) score += 4;
    if (Number(a.wallThicknessCm || a.wallThickness || 0) > 0) score += 4;
    if (Number(a.cornerCount || 0) >= 0) score += 2;
    if (String(a.masonryType || '').trim()) score += 2;
    if (String(a.moistureType || '').trim()) score += 2;
    if (Number(a.totalPriceIsofin || 0) > 0) score += 1;
    return score;
  }

  function normalizeAnalysis(raw) {
    if (!raw || typeof raw !== 'object') return null;
    var out = {};
    for (var k in raw) {
      if (Object.prototype.hasOwnProperty.call(raw, k)) out[k] = raw[k];
    }
    var bottles = Number(out.calculatedBottles || out.bottles || out.bottleCount || 0);
    if (!Number.isFinite(bottles) || bottles <= 0) return null;
    out.calculatedBottles = bottles;
    if (!(Number(out.bottles) > 0)) out.bottles = bottles;
    if (!(Number(out.bottleCount) > 0)) out.bottleCount = bottles;

    if (!(Number(out.drillSpacingCm) > 0) && Number(out.spacing) > 0) {
      out.drillSpacingCm = Number(out.spacing);
    }
    if (!(Number(out.drillAngleDeg) > 0) && Number(out.angle) > 0) {
      out.drillAngleDeg = Number(out.angle);
    }
    if (!(Number(out.wallThicknessCm) > 0) && Number(out.wallThickness) > 0) {
      out.wallThicknessCm = Number(out.wallThickness);
    }
    if (!(Number(out.drillDepthCm) > 0) && Number(out.drillDepth) > 0) {
      out.drillDepthCm = Number(out.drillDepth);
    }
    if (!hasCompleteAnalysis(out)) return null;
    return out;
  }

  function readStoredAnalysis() {
    var candidates = [];

    var directAnalysis = window.isofinCalculatorData && window.isofinCalculatorData.analysis;
    if (directAnalysis && typeof directAnalysis === 'object') candidates.push(directAnalysis);

    var stickySnapshot = readStorageJSONCandidates(STICKY_PANEL_ANALYSIS_KEY);
    for (var s0 = 0; s0 < stickySnapshot.length; s0++) candidates.push(stickySnapshot[s0]);

    var fromStorageModule = readStorageModuleJSON('analysis');
    if (fromStorageModule) candidates.push(fromStorageModule);
    var fromStorageModuleCalc = readStorageModuleJSON('calcState');
    if (fromStorageModuleCalc) candidates.push(fromStorageModuleCalc);

    var fromNamespaced = readNamespacedJSONCandidates('analysis');
    for (var n1 = 0; n1 < fromNamespaced.length; n1++) candidates.push(fromNamespaced[n1]);
    var fromNamespacedCalc = readNamespacedJSONCandidates('calcState');
    for (var n2 = 0; n2 < fromNamespacedCalc.length; n2++) candidates.push(fromNamespacedCalc[n2]);

    var legacyAnalysis = readStorageJSONCandidates('isofinAnalysis');
    for (var l1 = 0; l1 < legacyAnalysis.length; l1++) candidates.push(legacyAnalysis[l1]);
    var resumeAnalysis = readStorageJSONCandidates('__ISOWIZ_RESUME_ANALYSIS__');
    for (var r1 = 0; r1 < resumeAnalysis.length; r1++) candidates.push(resumeAnalysis[r1]);
    var resumeStep4Once = readStorageJSONCandidates('__ISOWIZ_RESUME_STEP4_ONCE__');
    for (var r2 = 0; r2 < resumeStep4Once.length; r2++) candidates.push(resumeStep4Once[r2]);
    var legacyCalcState = readStorageJSONCandidates('isofinCalcState');
    for (var l2 = 0; l2 < legacyCalcState.length; l2++) candidates.push(legacyCalcState[l2]);

    var iwCalc = window.IsoWiz && window.IsoWiz.Calculations;
    if (iwCalc && typeof iwCalc.loadAnalysisFromStorage === 'function') {
      try {
        var loaded = iwCalc.loadAnalysisFromStorage();
        if (loaded && typeof loaded === 'object') candidates.push(loaded);
      } catch (_) {}
    }
    if (iwCalc && typeof iwCalc.loadCalcStateFromStorage === 'function') {
      try {
        var loadedCalcState = iwCalc.loadCalcStateFromStorage();
        if (loadedCalcState && typeof loadedCalcState === 'object') candidates.push(loadedCalcState);
      } catch (_) {}
    }

    var best = null;
    var bestScore = -1;
    for (var i = 0; i < candidates.length; i++) {
      var normalized = normalizeAnalysis(candidates[i]);
      if (!normalized) continue;
      var score = scoreAnalysisCandidate(normalized);
      if (score > bestScore) {
        bestScore = score;
        best = normalized;
      }
    }

    return best;
  }

  function readStoredAnalysisNormalized() {
    return readStoredAnalysis();
  }

  function shouldPersistAnalysis(analysis) {
    if (!analysis || typeof analysis !== 'object') return false;
    if (Number(analysis.holeCount || 0) > 0 && Number(analysis.drillDepthCm || analysis.drillDepth || 0) > 0) return true;
    if (Number(analysis.wallThicknessCm || analysis.wallThickness || 0) > 0 && String(analysis.masonryType || '').trim()) return true;
    if (Number(analysis.totalPriceIsofin || 0) > 0) return true;
    return false;
  }

  function persistAnalysis(analysis) {
    if (!analysis) return;
    try {
      var payload = JSON.stringify(analysis);
      localStorage.setItem('isofinAnalysis', payload);
      sessionStorage.setItem('isofinAnalysis', payload);
      localStorage.setItem('__ISOWIZ_RESUME_ANALYSIS__', payload);
      sessionStorage.setItem('__ISOWIZ_RESUME_ANALYSIS__', payload);
    } catch (_) {}
  }

  function ensurePanelAnalysisContext() {
    var stored = readStoredAnalysisNormalized();
    if (!stored) return false;

    if (shouldPersistAnalysis(stored)) {
      persistAnalysis(stored);
    }

    if (!window.isofinCalculatorData || typeof window.isofinCalculatorData !== 'object') {
      window.isofinCalculatorData = {};
    }
    window.isofinCalculatorData.analysis = stored;

    var iw = (window.IsoWiz = window.IsoWiz || {});
    iw.Calculations = iw.Calculations || {};

    var currentGet = iw.Calculations.getFinalAnalysis;
    var bridgeFn = iw.Calculations.__sw2BridgeGetFinalAnalysis__;
    if (typeof bridgeFn !== 'function' || currentGet !== bridgeFn) {
      iw.Calculations.__sw2LiveGetFinalAnalysis__ =
        typeof currentGet === 'function' ? currentGet : null;

      iw.Calculations.__sw2BridgeGetFinalAnalysis__ = function() {
        var live = null;
        var liveFn = iw.Calculations.__sw2LiveGetFinalAnalysis__;
        if (typeof liveFn === 'function' && liveFn !== iw.Calculations.__sw2BridgeGetFinalAnalysis__) {
          try { live = liveFn(); } catch (_) {}
        }
        var normalizedLive = normalizeAnalysis(live);
        if (normalizedLive) {
          if (shouldPersistAnalysis(normalizedLive)) persistAnalysis(normalizedLive);
          return normalizedLive;
        }
        var normalizedStored = readStoredAnalysisNormalized();
        if (normalizedStored) {
          if (shouldPersistAnalysis(normalizedStored)) persistAnalysis(normalizedStored);
          return normalizedStored;
        }
        return null;
      };

      iw.Calculations.getFinalAnalysis = iw.Calculations.__sw2BridgeGetFinalAnalysis__;
    }

    return true;
  }

  function hasStoredResult() {
    var a = readStoredAnalysisNormalized();
    if (!a) return false;
    return hasCompleteAnalysis(a);
  }

  function hasStep4Marker() {
    var signatures = readStorageAll('isowiz_step4_completedSignature');
    for (var i = 0; i < signatures.length; i++) {
      if (signatures[i]) return true;
    }

    var returnFlags = readStorageAll('__ISOWIZ_RETURN_TO_STEP4__');
    for (var j = 0; j < returnFlags.length; j++) {
      if (String(returnFlags[j] || '') === '1') return true;
    }

    var steps = readStorageAll('__ISOWIZ_RESUME_STEP__');
    for (var k = 0; k < steps.length; k++) {
      var step = String(steps[k] || '').toLowerCase();
      if (step === '4' || step === 'step-4' || step === 'step4') return true;
    }
    return false;
  }

  function isPanelEligible(cart) {
    return bottleCount(cart) > 0 && hasStoredResult() && hasStep4Marker();
  }

  function getAssetBaseUrl() {
    if (window.ISOWIZ_ASSETS_BASE) return window.ISOWIZ_ASSETS_BASE;
    var base = '';
    try {
      var nodes = document.querySelectorAll('script[src*="/assets/"],link[href*="/assets/"]');
      for (var i = 0; i < nodes.length; i++) {
        var u = nodes[i].src || nodes[i].href;
        if (!u) continue;
        var m = u.match(/^(https?:\/\/[^/]+\/cdn\/shop\/t\/\d+\/assets\/)/);
        if (m) { base = m[1]; break; }
        m = u.match(/^(https?:\/\/[^/]+\/s\/files\/\d+\/\d+\/t\/\d+\/assets\/)/);
        if (m) { base = m[1]; break; }
      }
    } catch (_) {}
    if (!base && window.Shopify && window.Shopify.theme && window.Shopify.theme.id) {
      base = window.location.origin + '/cdn/shop/t/' + window.Shopify.theme.id + '/assets/';
    }
    if (base) window.ISOWIZ_ASSETS_BASE = base;
    return base;
  }

  function loadScriptWithFallback(primaryUrl, fallbackUrl, cacheKey) {
    if (SCRIPT_PROMISES[cacheKey]) return SCRIPT_PROMISES[cacheKey];
    SCRIPT_PROMISES[cacheKey] = new Promise(function(resolve, reject) {
      var triedFallback = false;
      function mount(url) {
        var s = document.createElement('script');
        s.src = url;
        s.async = true;
        s.onload = function() { resolve(); };
        s.onerror = function() {
          s.remove();
          if (!triedFallback && fallbackUrl) {
            triedFallback = true;
            mount(fallbackUrl);
            return;
          }
          reject(new Error('Script load failed: ' + url));
        };
        document.head.appendChild(s);
      }
      mount(primaryUrl);
    });
    return SCRIPT_PROMISES[cacheKey];
  }

  function installPreactCompat() {
    var preactLib = window.preact;
    var hooksLib = window.preactHooks;
    if (!preactLib || !hooksLib) return false;
    var ReactCompat = window.React || {};
    ReactCompat.createElement = preactLib.h;
    ReactCompat.Fragment = preactLib.Fragment;
    ReactCompat.useState = hooksLib.useState;
    ReactCompat.useEffect = hooksLib.useEffect;
    ReactCompat.useRef = hooksLib.useRef;
    ReactCompat.useMemo = hooksLib.useMemo || ReactCompat.useMemo;
    ReactCompat.useCallback = hooksLib.useCallback || ReactCompat.useCallback;
    ReactCompat.useLayoutEffect = hooksLib.useLayoutEffect || ReactCompat.useLayoutEffect;
    window.React = ReactCompat;
    if (!window.ReactDOM) window.ReactDOM = {};
    if (typeof window.ReactDOM.render !== 'function') {
      window.ReactDOM.render = function(vnode, container) { preactLib.render(vnode, container); return vnode; };
    }
    if (typeof window.ReactDOM.createRoot !== 'function') {
      window.ReactDOM.createRoot = function(container) {
        return {
          render: function(vnode) { preactLib.render(vnode, container); },
          unmount: function() { preactLib.render(null, container); }
        };
      };
    }
    if (typeof window.ReactDOM.unmountComponentAtNode !== 'function') {
      window.ReactDOM.unmountComponentAtNode = function(container) { preactLib.render(null, container); return true; };
    }
    return true;
  }

  function ensurePreactCompat() {
    if (window.React && typeof window.React.createElement === 'function' &&
        window.ReactDOM && (typeof window.ReactDOM.render === 'function' || typeof window.ReactDOM.createRoot === 'function')) {
      return Promise.resolve();
    }
    if (installPreactCompat()) return Promise.resolve();
    if (PREACT_COMPAT_PROMISE) return PREACT_COMPAT_PROMISE;
    PREACT_COMPAT_PROMISE = loadScriptWithFallback(
      'https://cdn.jsdelivr.net/npm/preact@10.26.4/dist/preact.umd.js',
      'https://unpkg.com/preact@10.26.4/dist/preact.umd.js',
      'preact-umd-10.26.4'
    ).then(function() {
      return loadScriptWithFallback(
        'https://cdn.jsdelivr.net/npm/preact@10.26.4/hooks/dist/hooks.umd.js',
        'https://unpkg.com/preact@10.26.4/hooks/dist/hooks.umd.js',
        'preact-hooks-umd-10.26.4'
      );
    }).then(function() {
      if (!installPreactCompat()) throw new Error('Preact compat install failed');
    });
    return PREACT_COMPAT_PROMISE;
  }

  function ensureAssetScript(filename) {
    var base = getAssetBaseUrl();
    if (!base) return Promise.reject(new Error('Asset base not found'));
    var version = encodeURIComponent(String(window.ISOWIZ_VERSION || Date.now()));
    var url = base + filename + '?v=' + version;
    return loadScriptWithFallback(url, null, 'asset:' + filename);
  }

  function ensurePanelRuntime(key) {
    var panelFile = CFG.PANEL_BOOT_FILES[key];
    if (!panelFile) return Promise.reject(new Error('Unknown panel key: ' + key));
    return ensurePreactCompat()
      .then(function() { return ensureAssetScript(CFG.PANEL_BOOT_FILES.sec03); })
      .then(function() {
        var inj = window.__ISOWIZ_STEP4_CSS_INJECTORS__ && window.__ISOWIZ_STEP4_CSS_INJECTORS__.sec03v2;
        if (typeof inj === 'function') {
          try { inj(); } catch (_) {}
        }
      })
      .then(function() { return ensureAssetScript(panelFile); });
  }

  /* ═══════════════════════════════════════════════════════════════════════
     CSS
  ═══════════════════════════════════════════════════════════════════════ */
  var CSS = `
#isofin-sw2-bar,
#isofin-sw2-bar *,
#isofin-sw2-menu *,
#isofin-sw2-overlay,
#isofin-sw2-modal-overlay,
.isofin-sw2-detail *,
.isofin-sw2-modal * {
  box-sizing: border-box !important;
}

/* ── VARIABLES ── */
#isofin-sw2-bar {
  --sw2-primary: #D6001C;
  --sw2-primary-dark: #A80016;
  --sw2-text: #202325;
  --sw2-muted: #5c636a;
  --sw2-border: rgba(0,0,0,0.08);
  --sw2-white: #ffffff;
  --sw2-ease: 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

/* ── STICKY BAR ── */
#isofin-sw2-bar {
  position: fixed !important;
  bottom: 0 !important; left: 0 !important; width: 100% !important;
  background: #fff !important;
  border-top: 1px solid rgba(0,0,0,0.08) !important;
  box-shadow: 0 -8px 32px rgba(0,0,0,0.06) !important;
  z-index: 9000 !important;
  padding: 10px 16px !important;
  padding-bottom: calc(10px + env(safe-area-inset-bottom, 0)) !important;
  display: flex !important; justify-content: space-between !important;
  align-items: center !important; gap: 12px !important;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
  transition: 0.4s cubic-bezier(0.16,1,0.3,1) !important;
}
#isofin-sw2-bar::after {
  content: '' !important; position: absolute !important;
  left: 0 !important; right: 0 !important; top: 100% !important;
  height: 300px !important; background: #fff !important; pointer-events: none !important;
}
#isofin-sw2-bar.sw2-anim-in {
  animation: sw2BarInMobile .36s cubic-bezier(0.16,1,0.3,1) both !important;
}
@keyframes sw2BarInMobile {
  0% { opacity: 0; transform: translateY(18px); }
  100% { opacity: 1; transform: translateY(0); }
}
@media (min-width: 768px) {
  #isofin-sw2-bar::after { display: none !important; }
  #isofin-sw2-bar.sw2-anim-in {
    animation: sw2BarInDesktop .36s cubic-bezier(0.16,1,0.3,1) both !important;
  }
  @keyframes sw2BarInDesktop {
    0% { opacity: 0; transform: translateX(-50%) translateY(16px); }
    100% { opacity: 1; transform: translateX(-50%) translateY(0); }
  }
}

.sw2-plan-btn {
  display: inline-flex !important; align-items: center !important; gap: 8px !important;
  background: transparent !important; border: none !important; padding: 8px 4px !important;
  font-size: 15px !important; font-weight: 600 !important; color: #202325 !important;
  cursor: pointer !important; transition: opacity .2s !important;
  font-family: inherit !important; white-space: nowrap !important;
}
.sw2-plan-btn:hover { opacity: .65 !important; }

/* v253 (2026-06-01): Checkout-CTA an die Startseiten-Buttons (.iso-btn--primary) angeglichen:
   flaches Voll-Rot statt Gradient, weicher Drop-Shadow statt Bevel/Glow, kein Text-Shadow,
   Rubik 600. Brand-Rot #D6001C (Source of Truth) beibehalten.
   Hover: abdunkeln + leichter Lift + größerer Schatten — wie die Startseiten-CTAs. */
.sw2-cta {
  display: flex !important; align-items: center !important;
  justify-content: center !important; gap: 8px !important;
  background: #D6001C !important;
  color: #fff !important; border: none !important; border-radius: 12px !important;
  padding: 13px 22px !important; font-size: 15px !important; font-weight: 600 !important;
  cursor: pointer !important; white-space: nowrap !important;
  font-family: 'Rubik', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
  box-shadow: 0 2px 6px rgba(214,0,28,.18) !important;
  transition: transform .2s ease, background .2s ease, box-shadow .2s ease !important;
  text-decoration: none !important; position: relative !important;
  text-shadow: none !important;
  flex-shrink: 0 !important;
}
.sw2-cta:hover { transform: translateY(-1px) !important; background: #A80016 !important; box-shadow: 0 8px 20px rgba(214,0,28,.30) !important; }
.sw2-cta-main {
  display: inline-flex !important;
  align-items: center !important;
  gap: 5px !important;
}
/* v360: Cart-State-Zweizeiler */
.sw2-cta.sw2-cta--2l { flex-direction: column !important; gap: 2px !important; line-height: 1.15 !important; padding-top: 9px !important; padding-bottom: 9px !important; }
.sw2-cta-line1 { display: inline-flex !important; align-items: center !important; gap: 8px !important; font-weight: 800 !important; }
.sw2-cta-line2 { display: block !important; font-size: 11px !important; font-weight: 600 !important; opacity: .92 !important; }
.sw2-cta-dot {
  display: inline-block !important;
  opacity: .95 !important;
  margin: 0 -1px !important;
}
.sw2-cta-price {
  display: inline-block !important;
  font-variant-numeric: tabular-nums !important;
}
/* v232.6 (2026-05-25): Shine-Effekt auf leerem CTA entfernt —
   transparenter Diagonal-Streifen bluetete out-of-bounds und lag störend über Hero/Hendrik. */
.sw2-cta.is-empty::before {
  content: none !important;
  display: none !important;
  animation: none !important;
  background: none !important;
}
.sw2-cta-arrow {
  display: inline-block !important; margin-left: 2px !important;
  animation: sw2-arrow 1.3s ease-in-out infinite !important;
}
.sw2-cta.is-empty:hover .sw2-cta-arrow { animation-duration: .6s !important; }
.sw2-fl { font-weight: 400 !important; font-size: .88em !important; opacity: .85 !important; }
/* v236.3: Free-Shipping Highlight im Sticky-CTA */
.sw2-free {
  font-weight: 700 !important; font-size: .88em !important;
  background: rgba(255,255,255,.16) !important;
  padding: 2px 10px !important; border-radius: 100px !important;
  margin-left: 10px !important;
  white-space: nowrap !important;
}
.sw2-cta--free { background: linear-gradient(180deg,#0A7D56 0%,#066b48 100%) !important; }
/* v237.1: Wenn Sanierungsplan-Button ausgeblendet ist (kein Sanierungspaket im Cart),
   wird der Zur-Kasse-CTA auf Mobile volle Breite + zentrierter Text.
   Desktop bleibt unverändert (Pill-Layout, content-sized). */
#isofin-sw2-bar.sw2-bar--cta-only { justify-content: center !important; }
@media (max-width: 767px) {
  #isofin-sw2-bar.sw2-bar--cta-only .sw2-cta {
    flex: 1 1 100% !important; width: 100% !important;
  }
}
/* v258 (2026-06-01): Desktop cta-only (nur Produkt im Cart, kein Plan-Button) —
   Pill-Padding symmetrisch. Sonst sitzt der einzelne "Zur Kasse"-CTA wegen des
   linken 24px-Paddings (war für den Plan-Button) zu weit rechts = Space links. */
@media (min-width: 768px) {
  #isofin-sw2-bar.sw2-bar--cta-only {
    padding-left: 14px !important;
    padding-right: 14px !important;
  }
}

@keyframes sw2-arrow  { 0%,100%{transform:translateX(0);} 50%{transform:translateX(4px);} }

/* v265: Mini SSL-Trust-Zeile im Sticky-Footer (ersetzt die alte 3-Badge-Trust-Zeile).
   Nur Mobile + nur im Cart-State ("Zur Kasse") sichtbar — eine schlanke Zeile unter dem CTA.
   Die 3 Trust-Badges (MPA / TUEV / Bewertungen) leben weiterhin im Cart-Drawer. */
.sw2-ssl { display: none !important; }
@media (max-width: 767px) {
  /* v488 (Bjoern): NIE stacken — Plan + Kasse bleiben immer nebeneinander.
     Vorher wrap → "Sanierungsplan" flog auf eine zweite Zeile (Livefund iPhone 15 Pro). */
  #isofin-sw2-bar { flex-wrap: nowrap !important; row-gap: 0 !important; }
  #isofin-sw2-bar.sw2-bar--cta-only .sw2-ssl {
    display: inline-flex !important; flex: 1 1 100% !important; order: 99 !important;
    align-items: center !important; justify-content: center !important; gap: 5px !important;
    margin: 1px 0 0 !important; padding: 0 !important;
    font-size: 10.5px !important; line-height: 1.2 !important;
    color: #6b7280 !important; font-weight: 600 !important; letter-spacing: .01em !important;
  }
  #isofin-sw2-bar.sw2-bar--cta-only .sw2-ssl svg { flex: none !important; opacity: .8 !important; }
}

/* Desktop: Floating Pill */
@media (min-width: 768px) {
  #isofin-sw2-bar {
    width: auto !important;
    bottom: 28px !important;
    left: 50% !important; transform: translateX(-50%) !important;
    border-radius: 100px !important;
    border: 1px solid rgba(0,0,0,0.08) !important;
    box-shadow: 0 12px 32px rgba(0,0,0,.12) !important;
    padding: 6px 8px 6px 24px !important; gap: 20px !important;
  }
  #isofin-sw2-bar.sw2-bar--empty {
    width: 90% !important; max-width: 1400px !important;
    padding: 8px 10px 8px 32px !important;
  }
  .sw2-cta { border-radius: 100px !important; padding: 15px 38px !important; }
}
@media (min-width: 1024px) {
  #isofin-sw2-bar.sw2-bar--empty { width: 70% !important; }
}

/* ── v488 (Bjoern): Sticky-Bar bleibt IMMER einzeilig ──────────────────────
   Kein Responsive-Umschalten der Beschriftung mehr (sah uneinheitlich aus) —
   der CTA ist jetzt dauerhaft kompakt ("Kasse" / "Preis · N Fl."), das passt
   ab 320px neben den Plan-Button. Einzige Reserve fuer sehr schmale Geraete:
   das Plan-Label kuerzt auf "Plan" (Icon bleibt, Ziel bleibt erreichbar). */
.sw2-plan-kurz { display: none !important; }
@media (max-width: 360px) {
  .sw2-plan-lang { display: none !important; }
  .sw2-plan-kurz { display: inline !important; }
}

/* ── v489.1 (Bjoern 16.07., Livefund per Screenshot): "auf dem handy ist massig
   platz und trotzdem steht nur Kasse" ─────────────────────────────────────────
   Erste v489-Fassung schaltete die volle Beschriftung erst ab 768px frei — viel
   zu konservativ. GEMESSEN (Offscreen-Klon, flex-unabhaengig): Plan-Button 124px,
   Button mit "Zur Kasse gehen" 170px, Bedarf neben dem Plan-Button 342px inkl.
   16px Sicherheitsluft → passt ab 360px. Bjoerns Handy (393px) hat 51px Luft.

   ZWEI getrennte Schwellen, bewusst:
   • ZEILE 1 (Label) schaltet schon ab 360px auf "Zur Kasse gehen". Der Button
     wird davon 170px breit und waechst NICHT mit der Bestellgroesse, weil …
   • ZEILE 2 (Menge) bleibt mobil bei "Fl." und wird erst ab 768px zu "Flaschen".
     Grund: "120 Flaschen · 2.388,00 €" waere breiter als der Button und koennte
     auf schmalen Handys stacken. "120 Fl. · 2.388,00 €" (104px) bleibt dagegen
     immer schmaler als "Zur Kasse gehen" (126px) → Button fix bei 170px, egal
     wie gross die Bestellung. So bleibt die v488-Regel "darf NIE stacken"
     garantiert erhalten (Bar ist flex-wrap:nowrap, CTA flex-shrink:0).

   Nur unter 360px (iPhone SE 1. Gen usw.) bleibt es bei "Kasse" / "Fl.".
   CSS-Umschaltung statt JS-Breitenabfrage: Das CTA-Markup wird nur bei
   Cart-Aenderungen gebaut, ein Resize fasst es nicht an — eine JS-Weiche waere
   beim Drehen des Geraets falsch stehen geblieben. */
.sw2-cta-lang, .sw2-fl-lang { display: none !important; }
@media (min-width: 360px) {
  .sw2-cta-kurz { display: none !important; }
  .sw2-cta-lang { display: inline !important; }
}
@media (min-width: 768px) {
  .sw2-fl-kurz { display: none !important; }
  .sw2-fl-lang { display: inline !important; }
}

@media (max-width: 767px) {
  #isofin-sw2-bar.sw2-bar--empty {
    justify-content: center !important;
  }
}

/* Empty state intro text – tablet + desktop only (≥641px), like V1 */
.sw2-empty-text {
  display: none !important;
  font-size: 14px !important; line-height: 1.4 !important;
  color: #202325 !important; opacity: 0.9; font-weight: 500 !important;
  max-width: 600px !important; flex: 1 !important;
}
.sw2-empty-text strong { font-weight: 700 !important; color: #D6001C !important; }
@media (min-width: 641px) {
  #isofin-sw2-bar.sw2-bar--empty .sw2-empty-text { display: block !important; }
}

/* ── OVERLAY (shared) ── */
#isofin-sw2-overlay,
#isofin-sw2-modal-overlay {
  position: fixed !important; inset: 0 !important;
  background: radial-gradient(ellipse at top right, rgba(10,10,12,.55) 0%, rgba(10,10,12,.35) 80%) !important;
  backdrop-filter: blur(2px) !important; -webkit-backdrop-filter: blur(2px) !important;
  opacity: 0 !important; visibility: hidden !important;
  transition: opacity .4s cubic-bezier(0.16,1,0.3,1), visibility .4s !important;
}
#isofin-sw2-overlay   { z-index: 9998 !important; }
#isofin-sw2-modal-overlay { z-index: 10000 !important; }
#isofin-sw2-overlay.is-open,
#isofin-sw2-modal-overlay.is-open { opacity: 1 !important; visibility: visible !important; }

/* ── MENU: BOTTOM SHEET (mobile) / SIDE PANEL (desktop) ── */
#isofin-sw2-menu {
  position: fixed !important; bottom: 0 !important; left: 0 !important; width: 100% !important;
  background: #fff !important;
  border-radius: 24px 24px 0 0 !important;
  box-shadow: 0 -12px 48px rgba(0,0,0,.15) !important;
  z-index: 9999 !important;
  transform: translateY(100%) !important;
  transition: transform .4s cubic-bezier(0.16,1,0.3,1) !important;
  display: flex !important; flex-direction: column !important;
  overflow: hidden !important; max-height: 75vh !important;
  font-family: inherit !important; font-variant-numeric: tabular-nums !important;
}
#isofin-sw2-menu.is-open { transform: translateY(0) !important; }
/* v488 (Bjoern): Fullscreen, wenn der Inhalt nicht in die 75vh-Schublade passt
   (gesetzt von syncMenuFullscreen beim Oeffnen — gemessen, nicht per Breakpoint
   geraten). Runde Ecken weg, weil sie im Vollbild oben freie Ecken zeigen wuerden;
   Safe-Area unten beachten (iPhone-Homebar). */
#isofin-sw2-menu.sw2-menu--full {
  max-height: 100dvh !important; height: 100dvh !important;
  border-radius: 0 !important;
  padding-bottom: env(safe-area-inset-bottom, 0) !important;
}
#isofin-sw2-menu.sw2-menu--full .sw2-handle { margin-top: env(safe-area-inset-top, 0) !important; }

.sw2-handle {
  width: 40px !important; height: 4px !important; background: #dee2e6 !important;
  border-radius: 4px !important; margin: 12px auto 0 !important; flex-shrink: 0 !important;
}
.sw2-menu-header {
  display: flex !important; align-items: center !important;
  justify-content: space-between !important;
  padding: 22px 24px 18px !important; flex-shrink: 0 !important;
  border-bottom: 1px solid rgba(0,0,0,0.08) !important;
}
.sw2-menu-title { font-size: 19px !important; font-weight: 700 !important; color: #111 !important; letter-spacing: -.01em !important; }
.sw2-menu-sub   { font-size: 12px !important; color: #666 !important; font-weight: 500 !important; margin-top: 3px !important; }
.sw2-icon-btn {
  width: 44px !important; height: 44px !important; border-radius: 50% !important;
  background: rgba(0,0,0,0.05) !important; border: none !important;
  display: flex !important; align-items: center !important; justify-content: center !important;
  font-size: 26px !important; color: #444 !important; cursor: pointer !important;
  transition: background .18s, color .18s !important; font-family: inherit !important;
  flex-shrink: 0 !important;
}
.sw2-icon-btn:hover { background: rgba(0,0,0,0.10) !important; color: #111 !important; }

.sw2-menu-body { padding: 20px 16px 24px !important; overflow-y: auto !important; }
.sw2-menu-list { display: flex !important; flex-direction: column !important; gap: 8px !important; list-style: none !important; width: 100% !important; margin: 0 !important; padding: 0 !important; }
.sw2-menu-item {
  display: flex !important; align-items: center !important; gap: 14px !important;
  width: 100% !important;
  padding: 16px !important; background: #fafafa !important;
  border: 1px solid rgba(0,0,0,0.08) !important; border-radius: 14px !important;
  cursor: pointer !important; transition: border-color .18s !important; text-decoration: none !important;
  color: #111 !important;
}
.sw2-menu-item:hover {
  border-color: rgba(0,0,0,0.14) !important;
}
.sw2-mi-icon  { font-size: 22px !important; width: 48px !important; text-align: center !important; flex-shrink: 0 !important; }
.sw2-mi-thumb {
  width: 48px !important; height: 48px !important; border-radius: 8px !important;
  object-fit: cover !important; flex-shrink: 0 !important;
  border: 1px solid rgba(0,0,0,0.06) !important;
}
.sw2-mi-text  { flex: 1 !important; }
.sw2-mi-main  { font-size: 15px !important; font-weight: 700 !important; display: block !important; margin-bottom: 2px !important; color: #111 !important; letter-spacing: -.005em !important; }
.sw2-mi-sub   { font-size: 12px !important; color: #666 !important; font-weight: 500 !important; display: block !important; }
.sw2-mi-arrow { color: #aaa !important; font-size: 18px !important; flex-shrink: 0 !important; }

/* Desktop: Side Panel */
@media (min-width: 768px) {
  #isofin-sw2-menu {
    top: 0 !important; bottom: 0 !important;
    left: auto !important; right: 0 !important;
    width: 420px !important; max-height: 100vh !important; height: 100% !important;
    border-radius: 0 !important;
    transform: translateX(100%) !important;
  }
  #isofin-sw2-menu.is-open { transform: translateX(0) !important; }
  .sw2-handle { display: none !important; }
  .sw2-menu-header { padding: 20px 24px 16px !important; border-bottom: 1px solid rgba(0,0,0,0.08) !important; }
  .sw2-menu-body { padding: 16px 16px 26px !important; }
  .sw2-menu-list { width: 100% !important; }
  .sw2-menu-item {
    width: 100% !important;
    min-height: 72px !important;
    padding: 16px 18px !important;
  }
  .sw2-mi-arrow {
    order: -1 !important;
    margin-right: 10px !important;
    margin-left: 0 !important;
    width: 18px !important;
    text-align: center !important;
    transform: rotate(180deg) !important;
  }
}

/* ── DETAIL SCREENS (Mobile fullscreen, slide from right) ── */
.sw2-detail {
  position: fixed !important; inset: 0 !important;
  background: #fff !important; z-index: 10000 !important;
  display: flex !important; flex-direction: column !important;
  transform: translateX(100%) !important;
  transition: transform .4s cubic-bezier(0.16,1,0.3,1), visibility .4s !important;
  visibility: hidden !important;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
}
.sw2-detail.is-open { transform: translateX(0) !important; visibility: visible !important; }

.sw2-detail-header {
  display: flex !important; align-items: center !important;
  justify-content: space-between !important;
  padding: 12px 20px !important; border-bottom: 1px solid rgba(0,0,0,0.08) !important;
  background: #FAFAFA !important; flex-shrink: 0 !important;
}
.sw2-back-btn {
  display: flex !important; align-items: center !important; gap: 5px !important;
  background: none !important; border: none !important; font-family: inherit !important;
  font-size: 14px !important; font-weight: 600 !important; color: #202325 !important;
  cursor: pointer !important; padding: 8px 8px 8px 0 !important;
  border-radius: 8px !important; transition: opacity .15s !important;
}
.sw2-back-btn:hover { opacity: .65 !important; }

.sw2-detail-scroll {
  flex: 1 !important; overflow-y: auto !important;
  -webkit-overflow-scrolling: touch !important; padding: 0 20px 20px !important;
}
.sw2-detail-title-wrap { padding: 20px 0 12px !important; text-align: center !important; }
.sw2-detail-title    { font-size: 20px !important; font-weight: 700 !important; color: #111827 !important; margin: 0 0 6px !important; line-height: 1.3 !important; }
.sw2-detail-subtitle { font-size: 14px !important; color: #6B7280 !important; margin: 0 !important; line-height: 1.5 !important; }
.sw2-panel-mount { /* panel content lands here */ }

.sw2-detail-footer {
  padding: 10px 16px !important; border-top: 1px solid rgba(0,0,0,0.08) !important;
  background: #fff !important; box-shadow: 0 -2px 8px rgba(0,0,0,.06) !important;
  flex-shrink: 0 !important;
}
.sw2-footer-cta {
  width: 100% !important; display: flex !important; flex-direction: column !important;
  align-items: center !important; justify-content: center !important; gap: 3px !important;
  background: linear-gradient(135deg, #C8102E 0%, #a00d25 100%) !important;
  color: #fff !important; border: none !important; border-radius: 12px !important;
  padding: 12px 20px !important; cursor: pointer !important; font-family: inherit !important;
  box-shadow: 0 4px 12px rgba(200,16,46,.3) !important;
  transition: transform .15s, box-shadow .15s !important;
}
.sw2-footer-cta:hover { transform: translateY(-2px) !important; box-shadow: 0 6px 16px rgba(200,16,46,.4) !important; }
.sw2-fcta-main { font-size: 15px !important; font-weight: 700 !important; color: #fff !important; }
.sw2-fcta-sub  { font-size: 11px !important; opacity: .9 !important; color: #fff !important; }

/* Loading state */
.sw2-panel-loading {
  padding: 40px 20px !important; text-align: center !important;
  color: #6B7280 !important; font-size: 14px !important;
}
.sw2-panel-error {
  border: 1px solid rgba(214,0,28,.18) !important;
  background: #fff6f7 !important;
  border-radius: 14px !important;
  padding: 16px !important;
  margin-top: 8px !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 10px !important;
}
.sw2-panel-error-title {
  font-size: 15px !important;
  font-weight: 700 !important;
  color: #7f1d1d !important;
  line-height: 1.35 !important;
}
.sw2-panel-error-text {
  font-size: 13px !important;
  color: #5c636a !important;
  line-height: 1.5 !important;
}
.sw2-panel-error-cta {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 8px !important;
  padding: 11px 14px !important;
  border-radius: 10px !important;
  background: #D6001C !important;
  color: #fff !important;
  text-decoration: none !important;
  font-size: 14px !important;
  font-weight: 700 !important;
  border: none !important;
  cursor: pointer !important;
}
.sw2-panel-error-cta:hover { filter: brightness(1.08) !important; }

/* Only show detail screens on mobile */
@media (min-width: 768px) { .sw2-detail { display: none !important; } }

/* ── DESKTOP MODALS ── */
.sw2-modal {
  position: fixed !important; top: 50% !important; left: 50% !important;
  transform: translate(-50%, -50%) scale(0.95) !important;
  width: 90% !important; max-width: 620px !important; max-height: 88vh !important;
  background: #fff !important; border-radius: 16px !important;
  box-shadow: 0 25px 50px -12px rgba(0,0,0,.25) !important;
  z-index: 10001 !important;
  display: none !important; flex-direction: column !important;
  opacity: 0 !important; visibility: hidden !important;
  transition: transform .35s cubic-bezier(0.16,1,0.3,1), opacity .35s, visibility .35s !important;
  overflow: hidden !important;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
}
@media (min-width: 768px) { .sw2-modal { display: flex !important; } }
.sw2-modal.is-open {
  opacity: 1 !important; visibility: visible !important;
  transform: translate(-50%, -50%) scale(1) !important;
}
.sw2-modal-header {
  display: flex !important; align-items: center !important;
  justify-content: space-between !important;
  padding: 12px 20px !important; border-bottom: 1px solid rgba(0,0,0,0.08) !important;
  background: #FAFAFA !important; flex-shrink: 0 !important;
}
.sw2-modal-back {
  background: none !important; border: none !important; font-family: inherit !important;
  font-size: 14px !important; font-weight: 500 !important; color: #374151 !important;
  cursor: pointer !important; padding: 8px 10px !important; margin: -8px 0 -8px -10px !important;
  border-radius: 8px !important; display: flex !important; align-items: center !important; gap: 4px !important;
  transition: background .15s !important;
}
.sw2-modal-back:hover { background: #eee !important; }
.sw2-modal-close {
  width: 36px !important; height: 36px !important; border-radius: 10px !important;
  background: none !important; border: none !important; font-size: 22px !important;
  color: #6B7280 !important; cursor: pointer !important;
  display: flex !important; align-items: center !important; justify-content: center !important;
  margin: -8px -8px -8px 0 !important; font-family: inherit !important;
  transition: background .15s !important;
}
.sw2-modal-close:hover { background: #eee !important; color: #111 !important; }
.sw2-modal-scroll {
  flex: 1 !important; overflow-y: auto !important;
  -webkit-overflow-scrolling: touch !important; padding: 0 20px 20px !important;
}
.sw2-modal-footer {
  padding: 10px 16px !important; border-top: 1px solid rgba(0,0,0,0.08) !important;
  background: #fff !important; box-shadow: 0 -2px 8px rgba(0,0,0,.06) !important;
  flex-shrink: 0 !important;
}

/* Detail screens + modals are handled entirely by sec-03's own drawer system.
   No additional CSS needed here for panel content. */
`;

  /* ═══════════════════════════════════════════════════════════════════════
     HTML
  ═══════════════════════════════════════════════════════════════════════ */
  function buildHTML() {
    function sw2PanelLi(key) {
      var p = PANELS[key];
      if (!p) return '';
      var iconEl = p.thumb
        ? '<img class="sw2-mi-thumb" src="' + sizedShopifyImage(p.thumb, 160) + '" alt="" loading="lazy" decoding="async" width="48" height="48">'
        : '<span class="sw2-mi-icon">' + p.icon + '</span>';
      return '<li class="sw2-menu-item" data-sw2-panel="' + key + '">' +
        iconEl +
        '<span class="sw2-mi-text">' +
        '<span class="sw2-mi-main">' + p.label + '</span>' +
        '<span class="sw2-mi-sub">' + p.sub + '</span>' +
        '</span>' +
        '<span class="sw2-mi-arrow">→</span>' +
        '</li>';
    }
    var sw2HowtoLi = '<li class="sw2-menu-item" data-sw2-howto="1">' +
      '<img class="sw2-mi-thumb" src="' + sizedShopifyImage('https://cdn.shopify.com/s/files/1/0846/5550/5691/files/isofin-stein-vergleich-800px.webp?v=1779275266', 160) + '" alt="" loading="lazy" decoding="async" width="48" height="48">' +
      '<span class="sw2-mi-text">' +
      '<span class="sw2-mi-main">Wie funktioniert Isofin®?</span>' +
      '<span class="sw2-mi-sub">Hydrophobierung einfach erklärt</span>' +
      '</span>' +
      '<span class="sw2-mi-arrow">→</span>' +
      '</li>';
    /* v309: Reihenfolge im Sanierungsplan-Menue: Anleitung → Wie funktioniert → Material */
    var menuItems = sw2PanelLi('anleitung') + sw2HowtoLi + sw2PanelLi('material');

    return '' +
      // Bar
      '<div id="isofin-sw2-bar" class="sw2-bar--empty" style="display:none !important">' +
      '<span class="sw2-empty-text"><strong>Isofin\u00ae</strong> \u2013 das Original aus deutscher Produktion bietet Ihnen lebenslange Sicherheit &amp; dauerhaft trockene W\u00e4nde.</span>' +
      '<button class="sw2-plan-btn" id="sw2-plan-btn" style="display:none" data-sw2-openmenu="1">' +
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>' +
      '<polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/>' +
      '</svg>' +
      /* v488: Label kuerzbar (Stufe 4 der Anti-Stack-Eskalation) — unter 375px
         bleibt nur "Plan" neben dem Icon, damit die Bar einzeilig bleibt. */
      '<span class="sw2-plan-lang">Sanierungsplan</span><span class="sw2-plan-kurz">Plan</span>' +
      '</button>' +
      /* v342: Hendrik-Avatar links neben dem Kasse-Button — nur sichtbar, wenn Warenkorb-
         Zustand UND Hendrik erreichbar (Mo–Fr 9–20, Sa 10–15). Klick öffnet die Kontakt-
         Schublade über den globalen data-iso-hendrik-open-Loader der Announcement-Bar. */
      '<span class="sw2-ctarow">' +
      '<button type="button" class="sw2-save" id="sw2-save" aria-label="Berechnung speichern \u2013 per WhatsApp, E-Mail oder Link">\uD83D\uDCBE<span>Speichern</span></button>' +
      '<button type="button" class="sw2-hendrik" id="sw2-hendrik" data-iso-hendrik-open data-iso-track="sticky_hendrik_click" data-iso-source="sticky" aria-label="Hendrik kontaktieren \u2013 Telefon, WhatsApp oder R\u00fcckruf">' +
      '<img src="https://cdn.shopify.com/s/files/1/0846/5550/5691/files/2026-hendrik-fluegge-blau-avatar-mittel-300px.jpg?v=1790351554&width=80" alt="" width="40" height="40" loading="lazy" decoding="async">' +
      '<span class="sw2-hendrik-dot" aria-hidden="true"></span>' +
      /* v501 (Björn 11.08.: »im sticky warenkorb footer da wo hendrik ist auf desktop,
         daneben vlt text. Kostenlose Expertenberatung«): Beschriftung neben dem Avatar.
         Erscheint erst ab 1024 px — zwischen 768 und 1023 px ist die Leiste zu eng,
         dort bleibt es beim reinen Avatar. aria-hidden, weil das aria-label des
         Knopfes die Funktion bereits vollstaendig beschreibt und der Text sie sonst
         doppelt vorgelesen wuerde. */
      '<span class="sw2-hendrik-text" aria-hidden="true">' +
      '<span class="sw2-hendrik-t1">Kostenlose</span>' +
      '<span class="sw2-hendrik-t2">Expertenberatung</span>' +
      '</span>' +
      '</button>' +
      '<a class="sw2-cta is-empty" id="sw2-cta" href="' + CFG.CALCULATOR_URL + '">' +
      'Sanierung berechnen <span class="sw2-cta-arrow">\u2192</span>' +
      '</a>' +
      '</span>' +
      /* v265: Mini SSL-Zeile - nur im Cart-State ("Zur Kasse") sichtbar (CSS), full-width unter dem CTA. */
      '<div class="sw2-ssl" aria-hidden="true">' +
      '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>' +
      '<span>SSL-gesicherte Bezahlung</span>' +
      '</div>' +
      '</div>' +
      // Overlay (menu only)
      '<div id="isofin-sw2-overlay"></div>' +
      // Menu
      '<div id="isofin-sw2-menu">' +
      '<div class="sw2-handle"></div>' +
      '<div class="sw2-menu-header">' +
      '<div><div class="sw2-menu-title">Sanierungsplan f\u00fcr Ihre Wand</div><div class="sw2-menu-sub" id="sw2-menu-sub">\u2013</div></div>' +
      '<button class="sw2-icon-btn" data-sw2-closemenu="1">\u00d7</button>' +
      '</div>' +
      '<div class="sw2-menu-body"><ul class="sw2-menu-list">' + menuItems +
      /* v360: Speichern im Sanierungsplan-Menü — Funnel-Logik: erst ansehen, dann sichern */
      '<li class="sw2-menu-item sw2-menu-item--save" data-sw2-save="1">' +
      '<span class="sw2-mi-icon">\uD83D\uDCBE</span>' +
      '<span class="sw2-mi-text">' +
      '<span class="sw2-mi-main">Berechnung speichern</span>' +
      '<span class="sw2-mi-sub">Per WhatsApp, E-Mail oder Link \u2013 f\u00fcr sp\u00e4ter</span>' +
      '</span>' +
      '<span class="sw2-mi-arrow">\u2192</span>' +
      '</li>' +
      '<li class="sw2-menu-item" data-sw2-kalkulator="1">' +
      '<span class="sw2-mi-icon">\uD83D\uDD04</span>' +
      '<span class="sw2-mi-text">' +
      '<span class="sw2-mi-main">Zur\u00fcck zur Berechnung</span>' +
      '<span class="sw2-mi-sub">\u00dcbersicht erneut \u00f6ffnen</span>' +
      '</span>' +
      '<span class="sw2-mi-arrow">\u2192</span>' +
      '</li>' +
      '</ul></div>' +
      '</div>';
  }

  /* ═══════════════════════════════════════════════════════════════════════
     PANEL DELEGATION  (sec-03 owns the drawer UI, we just call its globals)
  ═══════════════════════════════════════════════════════════════════════ */

  // Map panel key → global function name registered by sec-03
  var PANEL_FN_MAP = {
    anleitung: 'openGuideModal',
    material: 'openWerkzeugModal',
    wirkung: 'openGarantieModal'
  };
  var PANEL_TRACK_EVENT_MAP = {
    anleitung: 'futa_panel_anleitung_click',
    material: 'futa_panel_material_click',
    wirkung: 'futa_panel_wirkung_click'
  };

  function trackLogr3(eventName, payload) {
    if (!eventName || typeof window.logr3Track !== 'function') return;
    try {
      /* v247: Default step:true → /update statt /goal. Conversions kommen aus Customer Events Pixel. */
      window.logr3Track(eventName, Object.assign({ step: true }, payload || {}));
    } catch (_) {}
  }

  /* v288: Bar-Hoehe als CSS-Var publizieren — iso-purchase-toast (u.a.) stellt sich dynamisch darueber */
  function sw2PublishBarHeight() {
    try {
      var bar = document.getElementById('isofin-sw2-bar');
      var visible = bar && bar.getAttribute('data-sw2-visible') === '1';
      var h = visible ? Math.ceil(bar.getBoundingClientRect().height) : 0;
      document.documentElement.style.setProperty('--iso-sw2-h', h + 'px');
      if (visible && !sw2PublishBarHeight._wired) {
        sw2PublishBarHeight._wired = true;
        if (typeof ResizeObserver === 'function') { try { new ResizeObserver(function () { sw2PublishBarHeight(); }).observe(bar); } catch (_) {} }
        window.addEventListener('resize', sw2PublishBarHeight);
      }
    } catch (_) {}
  }

  function showPanelReloadHint() {
    var menuBody = document.querySelector('#isofin-sw2-menu .sw2-menu-body');
    var menuSub = document.getElementById('sw2-menu-sub');
    if (menuSub) menuSub.textContent = 'Berechnung neu starten erforderlich';
    if (!menuBody) {
      window.location.href = CFG.CALCULATOR_URL;
      return;
    }
    menuBody.innerHTML =
      '<div class="sw2-panel-error">' +
      '<div class="sw2-panel-error-title">Panel konnte nicht geladen werden</div>' +
      '<div class="sw2-panel-error-text">Bitte Berechnung erst neu starten. Danach steht der Sanierungsplan wieder vollständig zur Verfügung.</div>' +
      '<a class="sw2-panel-error-cta" href="' + CFG.CALCULATOR_URL + '">Berechnung neu starten</a>' +
      '</div>';
    openMenu();
  }

  function invokePanelFunction(key, fnName) {
    if (typeof window[fnName] !== 'function') return false;
    try {
      closeMenu();
      window[fnName]();
      trackLogr3(PANEL_TRACK_EVENT_MAP[key], {
        source: 'sticky_footer',
        panel_eligible: STATE.panelEligible ? 1 : 0,
        bottles: Number(STATE.lastBottleQty || 0)
      });
      return true;
    } catch (e) {
      console.warn('[SW2] Fehler beim Öffnen von ' + fnName + ':', e);
      return false;
    }
  }

  function callPanelFn(key) {
    var fnName = PANEL_FN_MAP[key];
    if (!fnName) return;

    if (!STATE.panelEligible) {
      showPanelReloadHint();
      return;
    }

    ensurePanelRuntime(key).then(function() {
      if (!ensurePanelAnalysisContext()) {
        showPanelReloadHint();
        return;
      }
      if (invokePanelFunction(key, fnName)) {
        return;
      }
      // Safety retry (late registration edge cases)
      var retries = 0;
      var iv = setInterval(function () {
        retries++;
        if (invokePanelFunction(key, fnName)) {
          clearInterval(iv);
        } else if (retries >= CFG.PANEL_RETRY_MAX) {
          clearInterval(iv);
          console.warn('[SW2] ' + fnName + ' nicht verfügbar nach ' + retries + ' Versuchen.');
          showPanelReloadHint();
        }
      }, CFG.PANEL_RETRY_MS);
    }).catch(function(err) {
      console.warn('[SW2] Panel-Laufzeit konnte nicht geladen werden:', err && err.message ? err.message : err);
      if (!ensurePanelAnalysisContext()) {
        showPanelReloadHint();
        return;
      }
      if (!invokePanelFunction(key, fnName)) showPanelReloadHint();
    });
  }

  /* ═══════════════════════════════════════════════════════════════════════
     UI ACTIONS
  ═══════════════════════════════════════════════════════════════════════ */
  /* v488 (Bjoern): Auf kleinen Displays Fullscreen, WENN der Inhalt nicht in die
     75vh-Schublade passt. Bewusst gemessen statt per Breakpoint geraten — die
     noetige Hoehe haengt am Inhalt (Menue hat je nach Cart-Zustand unterschiedlich
     viele Eintraege), nicht allein am Geraet. Passt alles, bleibt die vertraute
     Bottom-Sheet-Optik mit runden Ecken. */
  function syncMenuFullscreen() {
    var menu = document.getElementById('isofin-sw2-menu');
    if (!menu) return;
    menu.classList.remove('sw2-menu--full');           /* erst messen, dann entscheiden */
    var body = menu.querySelector('.sw2-menu-body');
    if (!body) return;
    var passtNicht = body.scrollHeight > body.clientHeight + 1;
    if (passtNicht) menu.classList.add('sw2-menu--full');
  }

  function openMenu() {
    /* v313.1: Gegenseitig ausschließen — Sanierungsplan-Schublade auf → Warenkorb zu. */
    try { if (window.IsoDashMiniCart && window.IsoDashMiniCart.close) window.IsoDashMiniCart.close(); } catch (_eCx) {}
    document.getElementById('isofin-sw2-menu').classList.add('is-open');
    document.getElementById('isofin-sw2-overlay').classList.add('is-open');
    document.body.classList.add('isofin-sw2-noscroll');
    /* nach dem Öffnen messen — vorher ist die Schublade noch translateY(100%) */
    try { requestAnimationFrame(syncMenuFullscreen); } catch (_eF) { syncMenuFullscreen(); }
  }
  function closeMenu() {
    document.getElementById('isofin-sw2-menu').classList.remove('is-open');
    document.getElementById('isofin-sw2-overlay').classList.remove('is-open');
    document.body.classList.remove('isofin-sw2-noscroll');
  }
  function closeAll() {
    closeMenu();
    closeHowto();
    document.body.classList.remove('isofin-sw2-noscroll');
  }

  /* v313.1: Globales Handle, damit der Warenkorb die Sanierungsplan-Schublade schließen kann (gegenseitiges Ausschließen). */
  window.IsofinStickyPlan = { openMenu: openMenu, closeMenu: closeMenu, closeAll: closeAll };

  /* ── "Wie funktioniert Isofin?" — eigenständiges Info-Overlay (keine Eligibility nötig) ── */
  function injectHowtoCss() {
    if (document.getElementById('sw2-howto-css')) return;
    var s = document.createElement('style');
    s.id = 'sw2-howto-css';
    s.textContent =
      '#isofin-sw2-howto{position:fixed;inset:0;z-index:9100;visibility:hidden;opacity:0;transition:opacity .25s ease,visibility .25s}' +
      '#isofin-sw2-howto.is-open{visibility:visible;opacity:1}' +
      '#isofin-sw2-howto .sw2ht-backdrop{position:absolute;inset:0;background:rgba(0,0,0,.55)}' +
      '#isofin-sw2-howto .sw2ht-panel{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%) scale(.98);width:min(560px,92vw);max-height:86vh;display:flex;flex-direction:column;background:#fff;border-radius:18px;overflow:hidden;box-shadow:0 24px 60px rgba(0,0,0,.3);transition:transform .25s ease;font-family:Rubik,-apple-system,sans-serif}' +
      '#isofin-sw2-howto.is-open .sw2ht-panel{transform:translate(-50%,-50%) scale(1)}' +
      '#isofin-sw2-howto .sw2ht-head{display:flex;align-items:center;justify-content:space-between;gap:14px;padding:15px 20px;background:linear-gradient(180deg,#D6001C 0%,#B8001A 100%);color:#fff;flex-shrink:0}' +
      '#isofin-sw2-howto .sw2ht-head-title{font-size:18px;font-weight:700}' +
      '#isofin-sw2-howto .sw2ht-close{width:34px;height:34px;border:none;border-radius:10px;background:rgba(255,255,255,.16);color:#fff;font-size:20px;cursor:pointer;display:flex;align-items:center;justify-content:center;flex-shrink:0}' +
      '#isofin-sw2-howto .sw2ht-body{padding:20px;overflow-y:auto;-webkit-overflow-scrolling:touch}' +
      '#isofin-sw2-howto .sw2ht-h2{font-size:20px;font-weight:700;color:#1a1a1a;margin:0 0 12px;line-height:1.2}' +
      '#isofin-sw2-howto .sw2ht-body p{font-size:16.5px;line-height:1.65;color:#333;margin:0 0 14px}' +
      '#isofin-sw2-howto .sw2ht-body strong{color:#1a1a1a;font-weight:600}' +
      '#isofin-sw2-howto .sw2ht-img{width:100%;height:auto;display:block;border-radius:12px;margin:4px 0 8px}' +
      '#isofin-sw2-howto .sw2ht-cap{font-size:14px;color:#666;text-align:center;font-weight:500;margin:0}' +
      '@media (max-width:600px){' +
        '#isofin-sw2-howto .sw2ht-panel{left:0;top:auto;bottom:0;transform:translateY(100%);width:100%;max-width:100%;max-height:90vh;border-radius:18px 18px 0 0}' +
        '#isofin-sw2-howto.is-open .sw2ht-panel{transform:translateY(0)}' +
        '#isofin-sw2-howto .sw2ht-body p{font-size:17.5px}' +
      '}';
    document.head.appendChild(s);
  }

  function openHowto() {
    closeMenu();
    injectHowtoCss();
    var ov = document.getElementById('isofin-sw2-howto');
    if (!ov) {
      ov = document.createElement('div');
      ov.id = 'isofin-sw2-howto';
      ov.innerHTML =
        '<div class="sw2ht-backdrop" data-sw2ht-close="1"></div>' +
        '<div class="sw2ht-panel" role="dialog" aria-modal="true" aria-label="Wie funktioniert Isofin">' +
          '<div class="sw2ht-head">' +
            '<div class="sw2ht-head-title">Wie funktioniert Isofin®?</div>' +
            '<button class="sw2ht-close" data-sw2ht-close="1" aria-label="Schließen">×</button>' +
          '</div>' +
          '<div class="sw2ht-body">' +
            '<h2 class="sw2ht-h2">Wie wirkt Isofin®?</h2>' +
            '<p>Isofin® ist ein <strong>hydrophobierendes Sperrsystem</strong>, das Mauerwerk wasserabweisend imprägniert, <strong>ohne die Poren zu verstopfen</strong>. Es wirkt ähnlich wie die Imprägnierung von Stoff oder Wildleder, die flüssiges Wasser abweist, aber Wasserdampf und Luft durchlässt.</p>' +
            '<p>Die Hydrophobierung macht die Porenwände wasserabweisend, ohne das Mauerwerk vollständig zu versiegeln. Wie schnell die Wand abtrocknet, hängt unter anderem von Wandaufbau, Feuchtebelastung und Raumklima ab.</p>' +
            '<p>Isofin® ist <strong>keine Verkieselung, keine wässrige Vergelung</strong> und enthält <strong>keine Nano-Partikel</strong>. Frei von Salzen und anderen bauschädlichen Inhaltsstoffen. Bei passendem Schadensbild bildet Isofin® eine hydrophobierende Sperrzone, die den weiteren kapillaren Feuchtenachschub begrenzt. Bereits vorhandene Salze, geschädigter Putz, Schimmel oder andere Folgeschäden müssen gesondert beurteilt und behandelt werden.</p>' +
            '<img class="sw2ht-img" src="https://cdn.shopify.com/s/files/1/0846/5550/5691/files/isofin-stein-vergleich-800px.webp?v=1779275266&width=800" alt="Isofin Stein-Vergleich — mit und ohne Behandlung" loading="lazy" decoding="async" width="800" height="600">' +
            '<p class="sw2ht-cap">Stein-Vergleich: mit und ohne Isofin®-Behandlung</p>' +
          '</div>' +
        '</div>';
      document.body.appendChild(ov);
      ov.addEventListener('click', function (e) {
        if (e.target.closest('[data-sw2ht-close]')) closeHowto();
      });
    }
    document.body.classList.add('isofin-sw2-noscroll');
    window.requestAnimationFrame(function () { ov.classList.add('is-open'); });
    try { trackLogr3('howto_isofin_open', { source: 'sticky_footer' }); } catch (e) {}
  }

  function closeHowto() {
    var ov = document.getElementById('isofin-sw2-howto');
    if (ov) ov.classList.remove('is-open');
    document.body.classList.remove('isofin-sw2-noscroll');
  }

  function smoothScrollToHero() {
    var hero = document.getElementById('hero');
    if (!hero) return false;
    try {
      hero.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return true;
    } catch (_) {
      window.location.hash = 'hero';
      return true;
    }
  }

  function consumePendingHeroScroll() {
    var pending = null;
    try { pending = sessionStorage.getItem(CFG.HERO_SCROLL_FLAG_KEY); } catch (_) {}
    if (!pending && window.location.hash !== '#hero') return;
    try { sessionStorage.removeItem(CFG.HERO_SCROLL_FLAG_KEY); } catch (_) {}
    setTimeout(function () { smoothScrollToHero(); }, 80);
  }

  function isMobileViewport() {
    try {
      if (window.matchMedia) return window.matchMedia('(max-width:' + CFG.MOBILE_MAX_WIDTH + 'px)').matches;
    } catch (_) {}
    return (window.innerWidth || 0) <= CFG.MOBILE_MAX_WIDTH;
  }

  function getScrollY() {
    return window.pageYOffset || document.documentElement.scrollTop || 0;
  }

  function shouldShowWhenEmpty() {
    var threshold = isMobileViewport() ? CFG.MOBILE_EMPTY_THRESHOLD : CFG.DESKTOP_EMPTY_THRESHOLD;
    return getScrollY() > threshold;
  }

  /* v315.1: Handbuch-Reader-Seiten erkennen (Shell rendert immer .hb-root). Einmal cachen. */
  var _isHandbuchReader;
  function isHandbuchReaderPage() {
    if (_isHandbuchReader === undefined) _isHandbuchReader = !!document.querySelector('.hb-root');
    return _isHandbuchReader;
  }

  function applyStickyVisibility() {
    var bar = document.getElementById('isofin-sw2-bar');
    if (!bar) return;
    /* v315.1: Auf den Handbuch-Reader-Seiten den Sticky-Warenkorb NIE anzeigen (Lese-Fokus).
       Hier im JS, weil das Einblenden display:flex !important inline setzt -> CSS allein reicht nicht.
       Bar bleibt versteckt + meldet Hoehe 0 (kein Padding-Spalt). JS laeuft normal weiter -> IsofinStickyPlan bleibt. */
    if (isHandbuchReaderPage()) {
      bar.setAttribute('data-sw2-visible', '0');
      bar.classList.remove('sw2-anim-in');
      bar.style.setProperty('display', 'none', 'important');
      sw2PublishBarHeight();
      return;
    }
    var isShown = bar.getAttribute('data-sw2-visible') === '1';
    if (STATE.showSticky) {
      if (!isShown) {
        bar.style.setProperty('display', 'flex', 'important');
        bar.classList.remove('sw2-anim-in');
        void bar.offsetWidth;
        bar.classList.add('sw2-anim-in');
        bar.setAttribute('data-sw2-visible', '1');
        sw2PublishBarHeight();
      } else {
        bar.style.setProperty('display', 'flex', 'important');
      }
      return;
    }
    bar.setAttribute('data-sw2-visible', '0');
    bar.classList.remove('sw2-anim-in');
    bar.style.setProperty('display', 'none', 'important');
    sw2PublishBarHeight();
  }

  function refreshStickyVisibility() {
    if (STATE.uiFilled) {
      STATE.showSticky = true;
    } else {
      STATE.showSticky = shouldShowWhenEmpty();
    }
    applyStickyVisibility();
  }

  /* ═══════════════════════════════════════════════════════════════════════
     CART RENDERING
  ═══════════════════════════════════════════════════════════════════════ */
  function renderEmpty() {
    var planBtn = document.getElementById('sw2-plan-btn');
    var cta = document.getElementById('sw2-cta');
    var bar = document.getElementById('isofin-sw2-bar');
    if (!planBtn || !cta) return;

    STATE.lastBottleQty = 0;
    STATE.uiFilled = false;
    planBtn.style.setProperty('display', 'none', 'important');
    cta.className = 'sw2-cta is-empty';
    cta.href = CFG.CALCULATOR_URL;
    cta.classList.remove('sw2-cta--2l');
    cta.innerHTML = 'Sanierung berechnen <span class="sw2-cta-arrow">→</span>';
    if (bar) bar.classList.add('sw2-bar--empty');
    refreshStickyVisibility();
  }

  function renderFilled(cart, panelEligible) {
    var planBtn = document.getElementById('sw2-plan-btn');
    var cta = document.getElementById('sw2-cta');
    var menuSub = document.getElementById('sw2-menu-sub');
    var bar = document.getElementById('isofin-sw2-bar');
    if (!planBtn || !cta) return;

    var total = cart.total_price || 0;
    var bottles = bottleCount(cart);          /* Sanierungspaket-Flaschen */
    STATE.lastBottleQty = bottles;
    STATE.uiFilled = true;

    /* v236.3: Sanierungsplan-Button nur, wenn Sanierungspaket auch wirklich
       im Cart liegt. Bei reinem Einzelflaschen-Cart (oder anderem Produkt)
       bleibt der Checkout-Button sticky, der Sanierungsplan wird ausgeblendet.
       v237.1: Wenn planBtn hidden → bar bekommt class 'sw2-bar--cta-only',
       damit der CTA mittig statt linksbündig steht (sonst bleibt das space-between-
       Layout aktiv und der einzelne CTA klebt am linken Rand). */
    /* v392 (Björn): Sanierungsplan NUR zeigen, wenn das Paket auch BERECHNET
       wurde — ohne Berechnung (z. B. Kauf über geteilten Bestell-Link auf
       fremdem Gerät) wäre der Plan leer. Gleiche hasCalc-Prüfung wie v379. */
    var planCalc = false;
    try {
      if (window.IsoSave && typeof window.IsoSave.hasAnalysis === 'function') planCalc = window.IsoSave.hasAnalysis();
      else { var _pa = JSON.parse(localStorage.getItem('isofinAnalysis') || 'null'); planCalc = !!(_pa && _pa.calculatedBottles > 0); }
    } catch (e) {}
    if (bottles > 0 && planCalc) {
      planBtn.style.setProperty('display', 'inline-flex', 'important');
      if (bar) bar.classList.remove('sw2-bar--cta-only');
    } else {
      planBtn.style.setProperty('display', 'none', 'important');
      if (bar) bar.classList.add('sw2-bar--cta-only');
    }

    cta.className = 'sw2-cta';
    cta.href = CFG.CHECKOUT_URL;
    /* v249: Kein "Gratis Versand"-Badge mehr (war Hauptverursacher des Mobile-Overflows). */
    var priceTxt = String(fmt(total)).replace(/\s*\u20ac/, ' \u20ac');
    cta.classList.add('sw2-cta--2l');
    /* v488 (Bjoern 16.07.): Die Bar darf NIE stacken (s. flex-wrap:nowrap im CSS).
       Vorher brach "Sanierungsplan" auf eine zweite Zeile um (145px Plan + 228px CTA
       + 32px Padding > 393px iPhone 15 Pro). Ursache-Bug: Das CSS blendete
       .sw2-zur/.sw2-fl-wrap aus — beide Klassen gab es im Markup NIE.
       Loesung ist bewusst KEINE Responsive-Eskalation (Bjoern: "sonst sieht das
       nicht gut aus"), sondern EINE feste, kompakte Fassung fuer alle Breiten:
       Zeile 1 "Kasse" (Hauptwort), Zeile 2 Flaschenzahl + Preis (Bjoern: erst Fl.). Der frueher
       breite Zusatz "· kostenloser Versand" und das "Zur" entfallen dauerhaft —
       damit passt der CTA ab 320px neben den Plan-Button. */
    cta.innerHTML = '<span class="sw2-cta-line1"><span class="sw2-cta-main">'
      + '<span class="sw2-cta-kurz">Kasse</span>'
      + '<span class="sw2-cta-lang">Zur Kasse gehen</span>'
      + '</span></span>'
      + '<span class="sw2-cta-line2">'
      + (bottles > 0
          ? '<span class="sw2-fl-kurz">' + bottles + ' Fl.</span>'
            + '<span class="sw2-fl-lang">' + bottles + ' Flaschen</span>'
            + ' \u00b7 '
          : '')
      + priceTxt + '</span>';
    if (bar) bar.classList.remove('sw2-bar--empty');

    if (menuSub && panelEligible && bottles > 0) {
      menuSub.textContent = bottles + ' Flaschen berechnet';
    } else if (menuSub) {
      menuSub.textContent = 'Panels nach Ergebnisberechnung verfügbar';
    }
    refreshStickyVisibility();
  }

  /* v410 (Björn: »Sticky braucht lange zum Umspringen« beim Seitenwechsel):
     Rendering von der Cart-Beschaffung getrennt — beim Boot wird zuerst der
     letzte bekannte Zustand (Session-Snapshot) SOFORT gerendert, der frische
     /cart.js-Abgleich korrigiert danach still (Token-Vergleich rendert nur
     bei tatsächlicher Änderung neu). */
  function renderCartObject(cart) {
    if (!cart) return;
    /* v410: DOM-Guard VOR dem Token-Vergleich — läuft der Snapshot-Render,
       bevor die Leiste gemountet ist, würde sonst der Token gesetzt und der
       spätere echte Cart-Abgleich als »unverändert« verschluckt. */
    if (!document.getElementById('sw2-cta') || !document.getElementById('sw2-plan-btn')) return;
    /* v313.2: Menü-Label (Sanierung berechnen ⇄ Berechnung ansehen) an Paket-im-Cart koppeln (bottleCount = Sanierungspaket-Variante). */
    /* v538: den Warenkorb selbst uebergeben — set(true) loeste bei jedem Abgleich
       einen eigenen /cart.js-Abruf im Kopfmenue aus (set(true) → refresh() → fetch). */
    try { if (window.IsofinCalcMenu) window.IsofinCalcMenu.set(cart); } catch (_eMx) {}

    var nextPanelEligible = isPanelEligible(cart);
    var token = tokenize(cart);
    var tokenChanged = token !== STATE.lastToken;
    var eligibilityChanged = nextPanelEligible !== STATE.panelEligible;
    if (!tokenChanged && !eligibilityChanged) return;
    STATE.lastToken = token;

    STATE.panelEligible = nextPanelEligible;
    /* v236.3: Filled-Modus auch für reine Einzelflaschen-Carts (item_count > 0),
       Sanierungspaket-Button wird in renderFilled je nach bottleCount sichtbar/versteckt. */
    if ((cart.item_count || 0) > 0) {
      renderFilled(cart, STATE.panelEligible);
    } else {
      renderEmpty();
    }
  }

  var SNAP_KEY = '__SW2_CART_SNAP__';
  /* v538: nie zwei Abrufe gleichzeitig — kommt waehrenddessen ein neuer Anlass,
     wird genau einmal nachgeladen (Ereignis-Buendel change→refresh→updated). */
  var _swInFlight = false, _swAgain = false;
  async function renderFromCart() {
    if (_swInFlight) { _swAgain = true; return; }
    _swInFlight = true;
    var cart;
    try { cart = await fetchCart(); } finally { _swInFlight = false; }
    if (_swAgain) { _swAgain = false; setTimeout(renderFromCart, 0); }
    if (!cart) return;
    try {
      sessionStorage.setItem(SNAP_KEY, JSON.stringify({
        item_count: cart.item_count || 0,
        total_price: cart.total_price || 0,
        items: (cart.items || []).map(function (i) { return { id: i.id, variant_id: i.variant_id, quantity: i.quantity }; })
      }));
    } catch (e) {}
    renderCartObject(cart);
  }

  /* ═══════════════════════════════════════════════════════════════════════
     EVENT DELEGATION  (one listener for entire component)
  ═══════════════════════════════════════════════════════════════════════ */
  function attachEvents() {
    document.addEventListener('click', function (e) {
      var checkoutCta = e.target && e.target.closest('#sw2-cta');
      if (checkoutCta && !checkoutCta.classList.contains('is-empty')) {
        if (typeof window.isoCheckoutIntent === 'function') {
          window.isoCheckoutIntent('sticky_footer', 'futa_zur_kasse_click', {
            bottles: Number(STATE.lastBottleQty || 0)
          });
        } else {
          trackLogr3('futa_zur_kasse_click', {
            source: 'sticky_footer',
            bottles: Number(STATE.lastBottleQty || 0)
          });
        }
      } else if (checkoutCta) {
        /* v271: Empty-State-CTA "Sanierung berechnen" → Kalkulator-Einstieg aus dem Sticky-Footer */
        trackLogr3('futa_calc_click', { source: 'sticky_footer' });
      }

      var el = e.target && e.target.closest(
        '[data-sw2-openmenu],[data-sw2-closemenu],[data-sw2-panel],[data-sw2-howto],[data-sw2-kalkulator],[data-sw2-checkout],[data-sw2-save]'
      );
      if (!el) return;

      if (el.dataset.sw2Openmenu) {
        /* v379: Speichern-Eintrag zum Anzeigezeitpunkt prüfen (nicht nur im Update-Zyklus) */
        try {
          var _mliCalc = false;
          if (window.IsoSave && typeof window.IsoSave.hasAnalysis === 'function') _mliCalc = window.IsoSave.hasAnalysis();
          else { var _ma = JSON.parse(localStorage.getItem('isofinAnalysis') || 'null'); _mliCalc = !!(_ma && _ma.calculatedBottles > 0); }
          var _mli = document.querySelector('.sw2-menu-item--save');
          if (_mli) _mli.classList.toggle('is-on', _mliCalc);
        } catch (e) {}
        trackLogr3('futa_sanierungsplan_click', {
          source: 'sticky_footer',
          bottles: Number(STATE.lastBottleQty || 0),
          panel_eligible: STATE.panelEligible ? 1 : 0
        });
        openMenu();
      }
      if (el.dataset.sw2Closemenu) closeMenu();
      if (el.dataset.sw2Panel) callPanelFn(el.dataset.sw2Panel);
      if (el.dataset.sw2Howto) {
        try { trackLogr3('howto_isofin_click', { source: 'sticky_footer' }); } catch (e) {}
        window.location.href = '/pages/wirkung';
        return;
      }
      if (el.dataset.sw2Save) {
        closeMenu();
        if (window.IsoSave && typeof window.IsoSave.open === 'function') window.IsoSave.open('menu');
      }
      if (el.dataset.sw2Kalkulator) window.location.href = CFG.CALCULATOR_URL;
      if (el.dataset.sw2Checkout) { trackLogr3('kalkulator_checkout_click', { source: 'sticky_footer', bottles: Number(STATE.lastBottleQty || 0) }); window.location.href = CFG.CHECKOUT_URL; }
    }, true);

    // Overlay closes menu
    var overlay = document.getElementById('isofin-sw2-overlay');
    if (overlay) overlay.addEventListener('click', closeMenu);

    // Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });

    /* v538: nach einer Warenkorb-Aenderung gezielt nachladen (ersetzt den 10-s-Burst). */
    var _swTimers = [];
    function refreshAfterChange() {
      _swTimers.forEach(clearTimeout);
      _swTimers = CFG.AFTER_CHANGE_MS.map(function (ms) { return setTimeout(renderFromCart, ms); });
    }

    // Cart mutation listeners
    var cartEvents = ['cart:refresh', 'cart:updated', 'ajaxCart:updated', 'product:added', 'isofin:cartUpdated', 'isofin:cart-updated'];
    cartEvents.forEach(function (evt) {
      document.addEventListener(evt, function (e) {
        /* v538: bringt das Ereignis den vollstaendigen Warenkorb mit (Drawer, Kalkulator),
           sofort daraus zeichnen — der Abruf danach bestaetigt nur noch. */
        /* Code-Check 21.09.: nur die Kalkulator-Ereignisse bringen sicher den FRISCHEN Warenkorb mit;
           die Schublade sendet nach dem Hinzufügen teils noch den alten Stand → dort nur nachladen. */
        var c = (evt === 'isofin:cartUpdated' || evt === 'isofin:cart-updated') && e && e.detail && e.detail.cart;
        if (c && typeof c.item_count === 'number' && Array.isArray(c.items) && typeof c.total_price === 'number') {
          renderCartObject(c);
        }
        refreshAfterChange();
      }, { passive: true });
    });

    // Intercept fetch cart mutations
    (function () {
      var _fetch = window.fetch;
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var p = _fetch(input, init);
        if (/\/cart\/(add|update|change|clear)/.test(url)) {
          p.then(refreshAfterChange).catch(function () { });
        }
        return p;
      };
    })();

    /* v538: Sicherheitsnetz-Abfrage nur im sichtbaren Tab; beim Zurueckkehren
       (Tab-Wechsel, Zurueck-Knopf aus dem Zwischenspeicher) einmal frisch laden. */
    setInterval(function () { if (!document.hidden) renderFromCart(); }, CFG.POLL_INTERVAL_MS);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) renderFromCart(); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) renderFromCart(); });

    // Body overflow guard
    var style = document.createElement('style');
    style.textContent = 'body.isofin-sw2-noscroll { overflow: hidden !important; }';
    document.head.appendChild(style);

    // Visibility behavior: filled cart => always visible, empty => after scroll depth
    var onViewportChange = function () { refreshStickyVisibility(); };
    setTimeout(onViewportChange, 100);
    window.addEventListener('scroll', onViewportChange, { passive: true });
    window.addEventListener('resize', onViewportChange);
    window.addEventListener('orientationchange', function () {
      setTimeout(onViewportChange, 100);
    });
  }

  /* ═══════════════════════════════════════════════════════════════════════
     MOUNT
  ═══════════════════════════════════════════════════════════════════════ */
  function ensureMount() {
    if (!document.getElementById('isofin-sw2-bar')) {
      var wrap = document.createElement('div');
      wrap.innerHTML = buildHTML();
      while (wrap.firstChild) document.body.appendChild(wrap.firstChild);
    }
    if (!document.getElementById('sw2-styles')) {
      var style = document.createElement('style');
      style.id = 'sw2-styles';
      style.textContent = CSS + SW2_HENDRIK_CSS;
      document.head.appendChild(style);
    }
  }

  /* ═══ v342: Hendrik-Avatar im Sticky — Erreichbarkeits-Gate ═══
     Sichtbar NUR wenn (a) die Leiste im Warenkorb-Zustand ist (CTA nicht .is-empty)
     und (b) Hendrik erreichbar ist (Europe/Berlin, Mo–Fr 9–20, Sa 10–15) —
     identische Logik wie Newsleiste/Kontakt-Schublade. Nicht erreichbar → komplett aus. */
  var SW2_HENDRIK_CSS = [
    '#isofin-sw2-menu .sw2-menu-item--save,#isofin-sw2-menu li.sw2-menu-item--save{display:none !important}',
    '#isofin-sw2-menu .sw2-menu-item--save.is-on,#isofin-sw2-menu li.sw2-menu-item--save.is-on{display:flex !important}',
    '#isofin-sw2-bar .sw2-hendrik{display:none;position:relative;flex:none;width:44px;height:44px;padding:0;margin:0;border:none;background:none;cursor:pointer;-webkit-tap-highlight-color:transparent;align-items:center;justify-content:center}',
    '@media (min-width:768px){#isofin-sw2-bar .sw2-hendrik.is-on{display:inline-flex}}',
    '#isofin-sw2-bar .sw2-hendrik img{width:40px;height:40px;border-radius:50%;object-fit:cover;display:block;border:2px solid #fff;box-shadow:0 1px 6px rgba(0,0,0,.25);transition:transform .15s ease}',
    '#isofin-sw2-bar .sw2-hendrik:hover img{transform:scale(1.08)}',
    '#isofin-sw2-bar .sw2-hendrik-dot{position:absolute;right:1px;bottom:1px;width:12px;height:12px;border-radius:50%;background:#22c55e;border:2px solid #fff;animation:sw2HendrikPulse 1.8s ease-in-out infinite}',
    /* v501: Beschriftung neben dem Avatar, erst ab 1024 px.
       Der Knopf wird dafuer von fester 44-px-Breite auf auto umgestellt; der
       gruene Punkt haengt sonst am rechten Rand des breiten Knopfes statt am
       Bild — deshalb wird er in dieser Stufe per left an das 40-px-Bild geheftet. */
    '#isofin-sw2-bar .sw2-hendrik-text{display:none;flex-direction:column;align-items:flex-start;text-align:left;line-height:1.15;white-space:nowrap}',
    '#isofin-sw2-bar .sw2-hendrik-t1{font-family:Rubik,-apple-system,sans-serif;font-size:11px;font-weight:600;color:#5c636a;letter-spacing:.01em}',
    '#isofin-sw2-bar .sw2-hendrik-t2{font-family:Rubik,-apple-system,sans-serif;font-size:13px;font-weight:700;color:#202325;letter-spacing:-.01em}',
    '@media (min-width:1024px){',
    '  #isofin-sw2-bar .sw2-hendrik.is-on{width:auto;gap:9px;padding:0 2px 0 0}',
    '  #isofin-sw2-bar .sw2-hendrik.is-on .sw2-hendrik-text{display:flex}',
    '  #isofin-sw2-bar .sw2-hendrik.is-on .sw2-hendrik-dot{right:auto;left:29px}',
    '}',
    '@keyframes sw2HendrikPulse{0%,100%{box-shadow:0 0 0 0 rgba(34,197,94,.6)}50%{box-shadow:0 0 0 5px rgba(34,197,94,0)}}',
    '@media (prefers-reduced-motion:reduce){#isofin-sw2-bar .sw2-hendrik-dot{animation:none}}',
    /* Avatar in dieselbe Umbruch-Zeile wie der Kasse-Button zwingen (links daneben) */
    /* v347: Wrapper ist standardmäßig UNSICHTBAR fürs Layout (display:contents) ->
       alle Original-Layouts (Leer-Zustand etc.) bleiben exakt erhalten. NUR wenn der
       Hendrik-Avatar sichtbar ist (Klasse has-hendrik, gesetzt vom Avatar-Gate),
       wird er eine echte Flex-Zeile, die Avatar + Kasse-Button zusammenhält. */
    '#isofin-sw2-bar .sw2-save{display:none;flex:0 0 auto;flex-direction:column;align-items:center;justify-content:center;gap:1px;width:58px;height:48px;padding:0;margin:0;box-sizing:border-box;background:#fff;border:2px solid #D6001C;border-radius:10px;color:#D6001C;font-size:15px;line-height:1;cursor:pointer;overflow:hidden;-webkit-tap-highlight-color:transparent}',
    '#isofin-sw2-bar .sw2-save span{font-size:8.5px;font-weight:700;letter-spacing:0;font-family:Rubik,-apple-system,sans-serif;white-space:nowrap}',
    '#isofin-sw2-bar .sw2-save.is-on{display:inline-flex}',
    '#isofin-sw2-bar .sw2-ctarow{display:contents}',
    '#isofin-sw2-bar .sw2-ctarow.has-save{display:inline-flex;align-items:center;gap:8px;flex:1 1 100%;min-width:0}',
    '#isofin-sw2-bar .sw2-ctarow.has-save .sw2-cta{flex:1 1 auto;min-width:0}',
    '@media (min-width:768px){#isofin-sw2-bar .sw2-ctarow.has-save{flex:0 0 auto}}',
    '#isofin-sw2-bar .sw2-ctarow.has-hendrik{display:inline-flex;align-items:center;gap:10px;flex:0 0 auto;min-width:0}',
    '#isofin-sw2-bar.sw2-bar--cta-only .sw2-ctarow.has-hendrik{flex:1 1 100%;width:100%}',
    '#isofin-sw2-bar .sw2-ctarow.has-hendrik .sw2-cta{flex:1 1 auto !important;width:auto !important}'
  ].join('');

  function sw2HendrikOpenNow() {
    try {
      var g = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Berlin' }));
      var day = g.getDay(), h = g.getHours();
      if (day >= 1 && day <= 5) return h >= 9 && h < 20;
      if (day === 6) return h >= 10 && h < 15;
      return false;
    } catch (e) { return false; }
  }
  function sw2HendrikUpdate() {
    var btn = document.getElementById('sw2-hendrik');
    var cta = document.getElementById('sw2-cta');
    if (!btn || !cta) return;
    var cartState = !cta.classList.contains('is-empty');
    var on = cartState && sw2HendrikOpenNow();
    btn.classList.toggle('is-on', on);
    var row = btn.closest('.sw2-ctarow');
    /* Desktop-only wie das Avatar-CSS: unter 768px bleibt der Wrapper aufgelöst */
    if (row) row.classList.toggle('has-hendrik', on && window.innerWidth >= 768);
    /* v360: Speichern-Button — sichtbar bei Warenkorb-Zustand + vorhandener Berechnung */
    var saveBtn = document.getElementById('sw2-save');
    if (saveBtn) {
      var hasCalc = false;
      try {
        if (window.IsoSave && typeof window.IsoSave.hasAnalysis === 'function') hasCalc = window.IsoSave.hasAnalysis();
        else { var _a = JSON.parse(localStorage.getItem('isofinAnalysis') || 'null'); hasCalc = !!(_a && _a.calculatedBottles > 0); }
      } catch (e) {}
      /* v362: Sticky-💾 auf Björns Wunsch ERSTMAL AUSGEBLENDET (06.07.2026).
         Wieder einschalten: SW2_SAVE_BUTTON auf true. Menü-Eintrag »Berechnung
         speichern«, Exit-Popup und Ergebnisseiten-Buttons bleiben aktiv. */
      var SW2_SAVE_BUTTON = false;
      var saveOn = SW2_SAVE_BUTTON && cartState && hasCalc;
      /* v379 (Logikfehler-Audit): Menü-Eintrag »Berechnung speichern« nur zeigen,
         wenn wirklich eine Berechnung existiert — vorher toter Klick für alle,
         die den Kalkulator nie benutzt haben. */
      /* v410 BUGFIX: »d« existiert hier nicht (Tippfehler aus v379) — der
         ReferenceError ließ boot() VOR dem ersten Render sterben; der Sticky
         erschien erst mit dem nächsten Poll/Event (Björns »springt spät um«). */
      var saveLi = document.querySelector('.sw2-menu-item--save');
      if (saveLi) saveLi.classList.toggle('is-on', hasCalc);
      saveBtn.classList.toggle('is-on', saveOn);
      var srow = saveBtn.closest('.sw2-ctarow');
      if (srow) srow.classList.toggle('has-save', saveOn);
    }
  }
  function sw2HendrikBoot() {
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('#sw2-save') : null;
      if (t && window.IsoSave && typeof window.IsoSave.open === 'function') window.IsoSave.open('sticky');
    });
    sw2HendrikUpdate();
    setInterval(sw2HendrikUpdate, 30000);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) sw2HendrikUpdate(); });
    window.addEventListener('resize', sw2HendrikUpdate);
    var cta = document.getElementById('sw2-cta');
    if (cta && window.MutationObserver) {
      new MutationObserver(sw2HendrikUpdate).observe(cta, { attributes: true, attributeFilter: ['class'] });
    }
  }

  function ensureAtBodyRoot() {
    function move() {
      ['isofin-sw2-bar', 'isofin-sw2-overlay', 'isofin-sw2-menu'].forEach(function (id) {
        var el = document.getElementById(id);
        if (el && el.parentNode !== document.body) document.body.appendChild(el);
      });
    }
    move();
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', move);
    var tries = 0;
    var t = setInterval(function () { move(); if (++tries > 20) clearInterval(t); }, 300);
  }

  /* ═══════════════════════════════════════════════════════════════════════
     BOOT
  ═══════════════════════════════════════════════════════════════════════ */
  function boot() {
    ensureMount();
    ensureAtBodyRoot();
    attachEvents();
    sw2HendrikBoot();
    consumePendingHeroScroll();
    refreshStickyVisibility();
    /* v410: letzten bekannten Cart-Zustand sofort zeigen — kein Warten auf /cart.js */
    try {
      var snap = JSON.parse(sessionStorage.getItem(SNAP_KEY) || 'null');
      if (snap) renderCartObject(snap);
    } catch (e) {}
    renderFromCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();
